import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/2.png';
import _imports_1 from '../assets/order.png';
import _imports_2 from '../assets/1.png';
import _imports_3 from '../assets/od_ss_avatar.png';
import _imports_4 from '../assets/ss_tel.png';
const _withScopeId = n => (_pushScopeId("data-v-87d826be"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "product"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-c-b"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "num"
}, "×1")], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title green"
}, "寄出信息", -1));
const _hoisted_9 = {
  class: "main"
};
const _hoisted_10 = {
  class: "info_title yellow"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  class: "edit_btn"
};
const _hoisted_13 = {
  key: 0,
  class: "main"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title purple"
}, "备注信息", -1));
const _hoisted_15 = {
  class: "main"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注:当您完成提交预约操作后，若存在疑问请拨打服务热线进行沟通，感谢您的配合!", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title blue"
}, "保价信息", -1));
const _hoisted_21 = {
  class: "main insured1"
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title blue"
}, "保价信息", -1));
const _hoisted_24 = {
  class: "main insured"
};
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-c-b\" data-v-87d826be><div data-v-87d826be><span class=\"title\" data-v-87d826be>若物品贵重，建议为物品保价</span><span class=\"title2\" data-v-87d826be>该服务不在免费兑换服务范围内，需额外加购</span></div><div class=\"img\" data-v-87d826be><img src=\"" + _imports_0 + "\" alt=\"\" data-v-87d826be></div></div>", 1);
const _hoisted_26 = {
  key: 0,
  class: "fyp"
};
const _hoisted_27 = {
  class: "price"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow1"
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"notice\" data-v-87d826be> 1.保价须知 <br data-v-87d826be> 保价由京东物流向消费者提供。若寄递物品时购买“保价”服务，可在保价范围内享受足额赔 <br data-v-87d826be> 2.保价范围损失全赔 <br data-v-87d826be> 消费者填写声明价值低于货物实际价值的，京东物流按照货物损失比例和声明价值进行赔偿，最高不超过声明价值。消费者填写声明价值高于货物实际价值的，京东物流按照实际损失进行赔偿，最高不超过货物实际价值 <br data-v-87d826be> 3.破损、丢失须知 <br data-v-87d826be> 货物在途破损、丢失，24h 内提交相关资料，7 天内交付处理意见 <br data-v-87d826be> 4.未保价须知 <br data-v-87d826be> 消费者未保价的快件，由于运输原因造成货物丢失或破损的京东物流每单赔偿最高额不超过损失部分运费的 6 倍 <br data-v-87d826be> 5.收取须知 <br data-v-87d826be> 物流取件时请客户自行包装、包装不退回、默认软包 </div>", 1);
const _hoisted_31 = {
  class: "radio"
};
const _hoisted_32 = {
  class: "footerBtn flex-c-b"
};
const _hoisted_33 = {
  key: 0,
  class: "price"
};
const _hoisted_34 = {
  key: 1
};
const _hoisted_35 = {
  style: {
    "text-align": "center",
    "padding-bottom": "10px"
  }
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "display": "block",
    "margin": "0 auto"
  },
  width: "80%",
  src: _imports_1
}, null, -1));
const _hoisted_37 = {
  style: {
    "font-weight": "bold",
    "font-size": "18px"
  }
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_39 = {
  style: {
    "color": "#646566"
  }
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title red"
}, "订单信息", -1));
const _hoisted_41 = {
  class: "main orderinfo"
};
const _hoisted_42 = {
  class: "status"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_44 = {
  class: "bottom"
};
const _hoisted_45 = {
  class: "time"
};
const _hoisted_46 = {
  class: "right"
};
const _hoisted_47 = {
  class: "name"
};
const _hoisted_48 = {
  class: "ordernum"
};
const _hoisted_49 = {
  class: "pickuptime"
};
const _hoisted_50 = {
  key: 0,
  class: "mailnum"
};
const _hoisted_51 = {
  key: 1,
  class: "mailnum"
};
const _hoisted_52 = {
  key: 0
};
const _hoisted_53 = {
  class: "flex-c"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title blue"
}, "鞋靴信息", -1));
const _hoisted_55 = {
  class: "main shoesinfo"
};
const _hoisted_56 = {
  class: "title"
};
const _hoisted_57 = {
  class: "imgs"
};
const _hoisted_58 = ["src", "onClick"];
const _hoisted_59 = {
  key: 0
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "瑕疵选项", -1));
const _hoisted_61 = {
  class: "tag"
};
const _hoisted_62 = {
  key: 1
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "异常备注", -1));
const _hoisted_64 = {
  class: "remark"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title green"
}, "寄出信息", -1));
const _hoisted_66 = {
  class: "main mailinfo flex-c"
};
const _hoisted_67 = {
  class: "left green"
};
const _hoisted_68 = {
  key: 0
};
const _hoisted_69 = {
  class: "right"
};
const _hoisted_70 = {
  class: "name"
};
const _hoisted_71 = {
  class: "tel"
};
const _hoisted_72 = {
  class: "adr"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title yellow"
}, "寄回信息", -1));
const _hoisted_74 = {
  class: "main mailinfo flex-c"
};
const _hoisted_75 = {
  class: "left yellow"
};
const _hoisted_76 = {
  key: 0
};
const _hoisted_77 = {
  class: "right"
};
const _hoisted_78 = {
  class: "name"
};
const _hoisted_79 = {
  class: "tel"
};
const _hoisted_80 = {
  class: "adr"
};
const _hoisted_81 = {
  key: 1
};
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title purple"
}, "备注信息", -1));
const _hoisted_83 = {
  class: "main remark"
};
const _hoisted_84 = {
  key: 2
};
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title blue"
}, "保价信息", -1));
const _hoisted_86 = {
  class: "main"
};
const _hoisted_87 = {
  key: 3
};
const _hoisted_88 = {
  class: "soilder_wrap"
};
const _hoisted_89 = {
  class: "list flex-c-b ide_wrap"
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ide_l flex-c-c"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "ide_avatar"
})], -1));
const _hoisted_91 = {
  class: "ide_r pl-20"
};
const _hoisted_92 = {
  class: "flex-c name_wrap"
};
const _hoisted_93 = {
  class: "flex-c mt-20 phone_wrap"
};
const _hoisted_94 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "ide_icon3"
}, null, -1));
const _hoisted_95 = ["href"];
const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ide_cont mt-20"
}, [/*#__PURE__*/_createTextVNode(" 该服务人员已通过全季到家技能与实名认证考核，如上门人员与接单人员信息不符，请拨打客服热线 "), /*#__PURE__*/_createElementVNode("strong", {
  class: "call_p"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "tel:40066-31115",
  class: "phone_text"
}, "40066-31115")]), /*#__PURE__*/_createTextVNode(" 进行确认。 ")], -1));
const _hoisted_97 = {
  key: 4,
  class: "cuslink flex-col"
};
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cuslink_tit"
}, "专属客服", -1));
const _hoisted_99 = {
  class: "cuslink_cont"
};
const _hoisted_100 = ["href"];
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "80px"
  }
}, null, -1));
const _hoisted_102 = {
  class: "footerBtn"
};
const _hoisted_103 = {
  class: "block"
};
const _hoisted_104 = {
  class: "kf_content"
};
const _hoisted_105 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "下单成功", -1));
const _hoisted_106 = {
  class: "link"
};
const _hoisted_107 = ["href"];
const _hoisted_108 = {
  class: "block"
};
const _hoisted_109 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "kf_content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title",
  style: {
    "color": "#AB0027"
  }
}, "需人工预约"), /*#__PURE__*/_createElementVNode("span", {
  class: "link"
}, [/*#__PURE__*/_createTextVNode("您所选择时间段订单爆满，请您拨打客服电话："), /*#__PURE__*/_createElementVNode("strong", {
  class: "call_p"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "tel:40066-31115",
  class: "phone_text"
}, "40066-31115")]), /*#__PURE__*/_createTextVNode("，联系客服协助您进行人工预约取件时间，给您带来不便敬请谅解。 ")])], -1));
const _hoisted_110 = {
  class: "wrapper"
};
const _hoisted_111 = {
  class: "block"
};
const _hoisted_112 = {
  class: "logistics flex-c-b"
};
const _hoisted_113 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "物流信息", -1));
import { ref, reactive, onMounted, getCurrentInstance, nextTick, toRaw } from "vue";
import { useRouter, useRoute } from "vue-router";
import _ from 'lodash';
import DateShose from "../components/dateShose.vue";
import commonMethod from '../common/common';
import { ImagePreview } from "vant";
import 'vant/es/image-preview/style';
export default /*#__PURE__*/_defineComponent({
  __name: 'reserveShose',
  setup(__props) {
    components: {
      DateShose;
    }
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    // 查询数据
    onMounted(() => {
      getData();
    });
    const showServe = ref(false); // 是否显示完成服务按钮
    // 查询数据
    const getData = () => {
      proxy.$api.post(`${proxy.$url}Index/get_soi`, {
        su: route.params.su
      }).then(res => {
        if (res.status == 1) {
          initData(res);
        } else {
          if (res.reserved == 3) {
            commonMethod.dialog('权益已废', '抱歉通知您,您已申请了退积分操作,该权益已废除,如需服务请重新兑换,感谢您的配合!', 1);
          } else {
            commonMethod.dialog('预约信息加载异常', '抱歉通知您，您的订单处于取消状态或由于系统繁忙，数据加载异常,请退出重试,感谢您的配合!', 1);
          }
        }
      }).catch(err => {
        console.log(err);
        commonMethod.dialog('预约信息加载异常', '抱歉通知您由于系统繁忙您的数据加载异常,请退出重试,感谢您的配合!', 1);
      });
    };
    // 处理页面数据
    const orderDetail = ref({});
    const isReserved = ref(false); // 是否已预约
    const overlayShow = ref(false); // 是否超90天
    const localAddress = ref(''); // 暂存详细地址
    const area_selected = ref(''); // 未预约的订单记录第一次的地址
    const showFail = ref(false);
    // 寄出信息
    const sendOutInfo = reactive({
      sa_id: 0,
      area: '',
      adr: '',
      doorplate: '',
      name: '',
      phone: '',
      date: ''
    });
    //寄回信息
    const sendBackInfo = reactive({
      sa_id: 0,
      area: '',
      adr: '',
      doorplate: '',
      name: '',
      phone: ''
    });
    const resStatus = ref(''); //预约状态
    const soldier = ref([]); // 服务兵信息
    const initData = res => {
      orderDetail.value = res.orderDetail;
      // 未预约
      if (res.reserved == 0) {
        // 如果超90天，提示不可预约
        if (orderDetail.value.is_over_days) {
          overlayShow.value = true;
          return;
        }
        // 预约省市区赋值
        sendOutInfo.sa_id = orderDetail.value.user_map_sa_id ? orderDetail.value.user_map_sa_id : orderDetail.value.res_sa_id ? orderDetail.value.res_sa_id : orderDetail.value.sa_id ? orderDetail.value.sa_id : 0;
        if (orderDetail.value.user_map_province && orderDetail.value.user_map_city && orderDetail.value.user_map_district) {
          sendOutInfo.area = area_selected.value = orderDetail.value.user_map_province + '/' + orderDetail.value.user_map_city + '/' + orderDetail.value.user_map_district;
        } else if (orderDetail.value.province && orderDetail.value.city && orderDetail.value.district) {
          sendOutInfo.area = area_selected.value = orderDetail.value.province + '/' + orderDetail.value.city + '/' + orderDetail.value.district;
        } else {
          orderDetail.value.rs_appid != "lsxd" && commonMethod.dialog('可服务区域变更提醒', '抱歉通知您,您兑换的商品可服务区域进行了变更或所选地址异常,请联系客服或选择新的地址进行预约,感谢您的配合!');
          sendOutInfo.area = '';
        }
        // 预约详细地址赋值
        sendOutInfo.adr = orderDetail.value.last_address || '';
        sendOutInfo.name = orderDetail.value.c_name || '';
        // sendOutInfo.phone = orderDetail.value.res_phone || '';
        getArea();
        nextTick(() => {
          let local = window.localStorage.getItem(orderDetail.value.vender_order_no);
          //如果缓存有数据，则显示为用户缓存过的详细地址
          if (local) {
            localAddress.value = sendOutInfo.adr = JSON.parse(local).adr;
            sendOutInfo.doorplate = JSON.parse(local).door;
          } else {
            localAddress.value = sendOutInfo.adr = orderDetail.value.user_map_address ? orderDetail.user_map_address : orderDetail.last_address;
            sendOutInfo.doorplate = orderDetail.value.user_map_doorplate;
          }
        });
      } else if (res.reserved == 1) {
        isReserved.value = true;
        // 时间显示赋值
        if (orderDetail.value.end_time) {
          judgeTime(orderDetail.value.res_time, orderDetail.value.end_time);
        } else {
          sendOutInfo.date = orderDetail.value.res_time;
        }
        if (orderDetail.value.oc_id != null && orderDetail.value.oc_id <= 0) {
          resStatus.value = '预约中';
          showFail.value = true;
        } else {
          switch (orderDetail.value.res_status) {
            case '1':
              resStatus.value = '预约成功';
              break;
            case '3':
              if (orderDetail.value.soo_status == 2 || orderDetail.value.finish_status == 1 || orderDetail.value.is_kf_opt == 1) {
                resStatus.value = '服务已完成';
              } else {
                resStatus.value = '等待上门取件';
              }
              break;
            case '4':
              resStatus.value = '预约已取消';
              break;
            default:
              break;
          }
        }
        // 判断是否有服务兵
        if (JSON.stringify(res.soldier) != '[]') {
          isMore.value = true;
          soldier.value = res.soldier;
          if (soldier.value.phone) {
            let reg = /^(.{3}).*(.{4})$/;
            soldier.value.real_phone = soldier.value.phone;
            soldier.value.phone = soldier.value.phone.replace(reg, '$1****$2');
          }
        }
        // 查找专属客服
        getKfLink();
      }
    };
    // 获取地址
    const areaOutList = ref([]); // 寄出地址列表
    const areaBackList = ref([]); // 寄回地址列表
    const defaultIndex = ref(''); // 选择地址默认选中
    const showOutArea = ref(false); // 是否显示寄出地址选择弹窗
    const showBackArea = ref(false); // 是否显示寄回地址选择弹窗
    const getArea = () => {
      proxy.$api.post(`${proxy.$url}ExpApi/getAreasNew`).then(res => {
        let list = res[4],
          province,
          city,
          district,
          i,
          j,
          k;
        if (sendOutInfo.area) {
          let arr = sendOutInfo.area.split('/');
          province = arr[0];
          city = arr[1];
          district = arr[2];
        }
        // 在数组中找到省市区的序号
        if (province != null && city != null && district != null) {
          i = list.findIndex(item => item.text == province);
          j = list[i].children.findIndex(item => item.text == city);
          k = list[i].children[j].children.findIndex(item => item.text == district);
        } else {
          i = j = k = 0;
        }
        areaOutList.value = [{
          values: list,
          className: 'province',
          defaultIndex: i
        }, {
          values: list[i].children,
          className: 'city',
          defaultIndex: j
        }, {
          values: list[i].children[j].children,
          className: 'area',
          defaultIndex: k
        }];
        areaBackList.value = JSON.parse(JSON.stringify(areaOutList.value));
      });
    };
    // 寄出地址选择联动时触发
    const outPicker = ref(null);
    const areaOutChange = (value, index) => {
      if (index == 0) {
        outPicker.value.setColumnValues(1, value[index].children);
        outPicker.value.setColumnValues(2, value[index].children[0].children);
        // 选择第一列时，如果第二列和第三列没有选择第一个，就更改选中
        if (areaOutList.value[1].defaultIndex > 0 || areaOutList.value[2].defaultIndex > 0) {
          areaOutList.value[1].defaultIndex = 0;
          areaOutList.value[2].defaultIndex = 0;
        }
      } else if (index == 1) {
        outPicker.value.setColumnValues(2, value[index].children);
        areaOutList.value[2].defaultIndex = 0;
      }
    };
    // 寄回地址选择联动时触发
    const backPicker = ref(null);
    const areaBackChange = (value, index) => {
      if (index == 0) {
        backPicker.value.setColumnValues(1, value[index].children);
        backPicker.value.setColumnValues(2, value[index].children[0].children);
        // 选择第一列时，如果第二列和第三列没有选择第一个，就更改选中
        if (areaOutList.value[1].defaultIndex > 0 || areaOutList.value[2].defaultIndex > 0) {
          areaOutList.value[1].defaultIndex = 0;
          areaOutList.value[2].defaultIndex = 0;
        }
      } else if (index == 1) {
        backPicker.value.setColumnValues(2, value[index].children);
        areaOutList.value[2].defaultIndex = 0;
      }
    };
    // 选择预约地址事件
    const res_time = ref(''); // 开始时间
    const end_time = ref(''); // 结束时间
    const areaChoose = (value, type) => {
      let checked = value[0].text + '/' + value[1].text + '/' + value[2].text;
      // 寄出选择
      if (type == 'out') {
        // 如果选择的地址和页面一样就return
        if (sendOutInfo.area == checked) return;
        sendOutInfo.adr = sendOutInfo.doorplate = '';
        // 如果选择的地址和接口的地址是一样的，就把值详细地址赋值
        if (checked == area_selected.value) {
          let local = window.localStorage.getItem(orderDetail.value.vender_order_no);
          if (local) {
            sendOutInfo.doorplate = JSON.parse(local).door || '';
            sendOutInfo.adr = JSON.parse(local).adr || '';
          } else {
            sendOutInfo.adr = localAddress;
          }
        }
        // 地址选中赋值
        sendOutInfo.area = checked;
        // sa_id赋值
        sendOutInfo.sa_id = value[2].sa_id;
        showOutArea.value = false;
        if (res_time.value) {
          // 选择完地址清空时间
          res_time.value = end_time.value = sendOutInfo.date = '';
        }
      } else {
        sendBackInfo.area = checked;
        sendBackInfo.sa_id = value[2].sa_id;
        showBackArea.value = false;
        sendBackInfo.adr = sendBackInfo.doorplate = '';
      }
    };
    // 详细地址输入
    const adrInput = () => {
      if (sendOutInfo.adr != localAddress.value) {
        // 地址变了就清空一下时间，重新请求日期
        sendOutInfo.date = res_time.value = end_time.value = '';
      }
    };
    const dateShose = ref(null);
    // 详细地址输入框失去焦点
    const adrBlur = type => {
      if (type == 'out') {
        localAddress.value = sendOutInfo.adr;
        setLocal();
        if (dateShose.value) {
          dateShose.value.clearList();
        }
      }
    };
    // 展开收起地址
    const switchState = () => {
      const isEqual = JSON.stringify(toRaw(sendOutInfo)) === JSON.stringify(toRaw(sendBackInfo));
      if (!sendBack.value && !isEqual) {
        Object.assign(sendBackInfo, sendOutInfo);
      }
      sendBack.value = !sendBack.value;
    };
    // 选择时间
    const showTime = ref(false);
    const dealAddress = () => {
      if (!sendOutInfo.area) {
        commonMethod.notify('warning', '请先选择省市区');
        return;
      }
      if (!sendOutInfo.adr) {
        commonMethod.notify('warning', '请先填写详情地址');
        return;
      }
      if (!sendOutInfo.name) {
        commonMethod.notify('warning', '请先填写联系人');
        return;
      }
      if (!sendOutInfo.phone) {
        commonMethod.notify('warning', '请先填写手机号');
        return;
      }
      showTime.value = true;
      let reg = new RegExp('/', 'g');
      let area = sendOutInfo.area.replace(reg, '');
      nextTick(() => {
        sendOutInfo.date = res_time.value = end_time.value = '';
        dateShose.value.getWashDate(orderDetail.value.s_id, sendOutInfo.name, sendOutInfo.phone, area + sendOutInfo.adr, sendOutInfo.date);
      });
    };
    // 预约时间选择
    const timeChoose = (date, start, end) => {
      showTime.value = false;
      if (!date) return;
      sendOutInfo.date = date + ' ' + start + '-' + end;
      res_time.value = date + ' ' + start;
      end_time.value = date + ' ' + end;
    };
    // 提交预约
    const adrOut = ref(null);
    const nameOut = ref(null);
    const phoneOut = ref(null);
    const doorplateOut = ref(null);
    const adrBack = ref(null);
    const doorplateBack = ref(null);
    const nameBack = ref(null);
    const phoneBack = ref(null);
    const sendBack = ref(true); // 是否和寄件地址一直
    const toSave = () => {
      if (!sendOutInfo.area) {
        commonMethod.notify('warning', '请选择地址');
        return;
      }
      if (!sendOutInfo.adr) {
        commonMethod.notify('warning', '请填写详情地址');
        adrOut.value.focus();
        return;
      }
      if (!sendOutInfo.doorplate) {
        commonMethod.notify('warning', '请填写门牌号');
        doorplateOut.value.focus();
        return;
      }
      if (!sendOutInfo.name) {
        nameOut.value.focus();
        commonMethod.notify('warning', '请填写联系人姓名');
        return;
      }
      if (!/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(sendOutInfo.phone)) {
        commonMethod.notify('warning', '手机号码错误');
        phoneOut.value.focus();
        return;
      }
      if (!res_time.value || res_time.value == '' || res_time.value == null) {
        commonMethod.notify('warning', '请选择期望上门时间');
        return;
      }
      // 如果寄出地址和寄回地址相同，直接请求
      if (sendBack.value) {
        if (fyp.value > 0 && !orderDetail.value.is_insured) {
          toPay();
        } else {
          toSubmit();
        }
      }
      // 如果寄回地址和寄出地址不一致，再检查一遍寄回地址
      if (!sendBack.value) {
        nextTick(() => {
          if (!sendBackInfo.area) {
            commonMethod.notify('warning', '请选择地址');
            return;
          }
          if (!sendBackInfo.adr) {
            commonMethod.notify('warning', '请填写详情地址');
            adrBack.value.focus();
            return;
          }
          if (!sendBackInfo.doorplate) {
            commonMethod.notify('warning', '请填写门牌号');
            doorplateBack.value.focus();
            return;
          }
          if (!sendBackInfo.name) {
            nameBack.value.focus();
            commonMethod.notify('warning', '请填写联系人姓名');
            return;
          }
          if (!/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(sendBackInfo.phone)) {
            commonMethod.notify('warning', '手机号码错误');
            phoneBack.value.focus();
            return;
          }
          if (fyp.value > 0 && !orderDetail.value.is_insured) {
            toPay();
          } else {
            toSubmit();
          }
        });
      }
    };
    // 支付
    const accord = ref(false); // 报价协议勾选
    const toPay = () => {
      if (fyp.value > 0 && !accord.value) {
        commonMethod.notify('warning', '请先勾选物流运输保价须知');
        return;
      }
      // 如果有保价就提交支付
      if (fyp.value > 0) {
        proxy.$api.post(`${proxy.$url}WeChatPay/getPayUrl`, {
          vender_order_no: orderDetail.value.vender_order_no,
          wx_pay_code: orderDetail.value.wx_pay_code,
          insured_money: price.value
        }).then(res => {
          if (res.data) {
            window.location.replace(res.data.payurl);
          } else {
            commonMethod.notify('error', '调用支付失败');
          }
        }).catch(() => {});
      }
    };
    // 请求提交预约接口
    const remark = ref(''); // 备注
    const toSubmit = () => {
      // 如果选择的是一小时内，就把开始时间赋值为提交订单的时间
      if (sendOutInfo.date.includes('小时内')) {
        let dateArr = getHourDifference(res_time.value.split(' ')[1], end_time.value.split(' ')[1]);
        res_time.value = dateArr[0];
        end_time.value = dateArr[1];
      }
      let reg = new RegExp('/', 'g');
      let receiverBackName, receiverBackMobile, receiverBackAddress;
      // 如果寄回地址一样
      if (sendBack.value) {
        receiverBackName = sendOutInfo.name;
        receiverBackMobile = sendOutInfo.phone;
        receiverBackAddress = sendOutInfo.area.replace(reg, '') + sendOutInfo.adr + sendOutInfo.doorplate;
      } else {
        receiverBackName = sendBackInfo.name;
        receiverBackMobile = sendBackInfo.phone;
        receiverBackAddress = sendBackInfo.area.replace(reg, '') + sendBackInfo.adr + sendBackInfo.doorplate;
      }
      commonMethod.toast('loading', '正在提交...', 0);
      proxy.$api.post(`${proxy.$url}ExpApi/toSave`, {
        soi_id: orderDetail.value.soi_id,
        sa_id: sendOutInfo.sa_id,
        c_name: sendOutInfo.name,
        c_phone: sendOutInfo.phone,
        address: sendOutInfo.adr + sendOutInfo.doorplate,
        res_time: res_time.value,
        end_time: end_time.value,
        remark: remark.value,
        uCode: orderDetail.value.shorturl,
        lat: 0,
        lng: 0,
        receiverBackName,
        receiverBackMobile,
        receiverBackAddress
        // am_id: manager_id.value
      }).then(res => {
        commonMethod.toast('clear');
        if (res.status == 1) {
          getData();
        } else {
          commonMethod.notify('warning', '预约失败');
        }
        window.localStorage.clear();
      }).catch(err => {
        commonMethod.toast('clear');
        commonMethod.toast('', '预约失败');
      });
    };
    // 保费计算
    const price = ref(''); //需要保价的价格
    const fyp = ref(0); //应付保费
    const priceInput = _.debounce(() => {
      price.value = Number(price.value);
      if (price.value <= 0) {
        price.value = '';
        fyp.value = 0;
        return;
      }
      if (price.value > 0 && price.value < 1) {
        price.value = 1;
        commonMethod.notify('warning', '最小保价金额为1元');
      } else if (price.value > 2000) {
        price.value = 2000;
        commonMethod.notify('warning', '最大保价金额为2000元');
      }
      fyp.value = Number(price.value * 0.002) < 1 ? '2.00' : (Number(price.value * 0.002) * 2).toFixed(2);
    }, 300);
    // 存储地址和门牌号信息
    const setLocal = () => {
      let obj = {
        adr: sendOutInfo.adr,
        door: sendOutInfo.doorplate
      };
      window.localStorage.setItem(orderDetail.value.vender_order_no, JSON.stringify(obj));
    };
    // 获取鞋靴信息
    const shoesData = ref([]); // 鞋靴信息
    const showShoseInfo = ref(false); // 展开鞋靴信息
    const isHttpShose = ref(false); // 是否已经请求鞋靴信息
    const openShoseInfo = () => {
      showShoseInfo.value = !showShoseInfo.value;
      // 如果已经请求过接口就不在请求
      if (isHttpShose.value) {
        return;
      }
      proxy.$api.post(`${proxy.$url}Shoes/getShoesInformation`, {
        soi_id: orderDetail.value.soi_id
      }).then(res => {
        shoesData.value = res.data.child_data;
        showShoseInfo.value = true;
        isHttpShose.value = true;
      }).catch(err => {
        commonMethod.dialog('鞋靴信息加载异常', '抱歉通知您由于系统繁忙您的数据加载异常,请退出重试,感谢您的配合!');
      });
    };
    // 打开物流信息弹窗
    const showLogistics = ref(false); // 展示物流信息
    const logisticsInfo = ref([]); // 物流信息
    const openLogistics = value => {
      if (value.length <= 0) {
        commonMethod.Toast('', '暂无物流信息');
      } else {
        showLogistics.value = true;
        logisticsInfo.value = value;
      }
    };
    // 查看图片
    const previewImg = (lists, index) => {
      let images = [];
      lists.map(item => {
        images.push(item.img_url);
      });
      ImagePreview({
        images: images,
        showIndex: true,
        loop: true,
        startPosition: index,
        closeable: true
      });
    };
    // 显示时间判断，防止结束时间小于开始时间
    const judgeTime = (start_time, end_time) => {
      let arr = start_time.split(':');
      // 如果开始时间大于结束时间，就直接显示开始时间，不显示结束时间
      if (new Date(start_time).getTime() > new Date(end_time).getTime()) {
        orderDetail.value.date = arr[0] + ':' + arr[1];
      } else {
        let arr1 = end_time.split(' ');
        let arr2 = arr1[1].split(':');
        orderDetail.value.date = arr[0] + ':' + arr[1] + '-' + arr2[0] + ':' + arr2[1];
      }
    };
    // 计算相差小时数并且返回当前时间和相差小时后的时间
    const getHourDifference = (time1, time2) => {
      // 将时间转换为日期对象
      let date1 = new Date('1970-01-01T' + time1 + 'Z');
      let date2 = new Date('1970-01-01T' + time2 + 'Z');
      // 计算相差的毫秒数
      let diff = date2.getTime() - date1.getTime();
      // 相差的小时数
      let hours = diff / (1000 * 60 * 60);
      // 计算当前时间和相差小时候的时间
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const hour1 = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      ;
      let hour2 = new Date(date.setHours(date.getHours() + hours)).getHours();
      if (hour2 < 10) {
        hour2 = '0' + h2;
      }
      const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      let start = `${year}-${month}-${day} ${hour1}:${minute}:${second}`;
      let end = `${year}-${month}-${day} ${hour2}:${minute}:${second}`;
      return [start, end];
    };
    // 专属客服链接
    const isBind = ref('');
    const kfLink = ref('');
    const showKf = ref(false); // 专属客服弹窗
    const getKfLink = () => {
      proxy.$api.post(`${proxy.$wxurl}H5/Kefu/showKefu`, {
        vender_order_no: orderDetail.value.vender_order_no
      }).then(res => {
        isBind.value = res.data.bind_kefu;
        kfLink.value = res.data.kf_url;
        if (res.data.kf_url && (resStatus.value == '预约成功' || resStatus.value == '等待上门取件')) {
          showKf.value = true;
        }
      });
    };
    // 绑定专属客服链接
    const bindKfLink = () => {
      if (isBind.value) {
        return;
      }
      proxy.$api.post(`${proxy.$url}H5/Kefu/showKefu`, {
        vender_order_no: orderDetail.value.vender_order_no
      });
    };
    // 跳转保价协议
    const goAccord = () => {
      router.push({
        path: '/accord'
      });
    };
    // 拨打电话
    const callCS = () => {
      window.location.href = 'tel:4006631115';
    };
    // 返回上一页
    const back = () => {
      window.history.go(-1);
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_checkbox = _resolveComponent("van-checkbox");
      const _component_van_overlay = _resolveComponent("van-overlay");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_step = _resolveComponent("van-step");
      const _component_van_steps = _resolveComponent("van-steps");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [isReserved.value != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_nav_bar, {
        title: "服务预约",
        "left-arrow": "",
        border: "",
        fixed: "",
        placeholder: "",
        onClickLeft: back
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: orderDetail.value.cover_pic,
        alt: ""
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(orderDetail.value.s_name), 1), _hoisted_7])]), _createElementVNode("div", null, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_field, {
        label: "省市区",
        modelValue: sendOutInfo.area,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => sendOutInfo.area = $event),
        placeholder: "选择省市区",
        readonly: "",
        clickable: "",
        onClick: _cache[1] || (_cache[1] = $event => showOutArea.value = true),
        class: "adr"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: showOutArea.value,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => showOutArea.value = $event),
        position: "bottom",
        style: {
          height: '40%'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          "show-toolbar": "",
          columns: areaOutList.value,
          "default-index": defaultIndex.value,
          onChange: areaOutChange,
          onConfirm: _cache[2] || (_cache[2] = $event => areaChoose($event, 'out')),
          onCancel: _cache[3] || (_cache[3] = $event => showOutArea.value = false),
          ref_key: "outPicker",
          ref: outPicker
        }, null, 8, ["columns", "default-index"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        label: "街道小区",
        modelValue: sendOutInfo.adr,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => sendOutInfo.adr = $event),
        placeholder: "填写街道、小区",
        onInput: adrInput,
        onBlur: _cache[6] || (_cache[6] = $event => adrBlur('out')),
        ref_key: "adrOut",
        ref: adrOut,
        class: "adr"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "门牌号码",
        modelValue: sendOutInfo.doorplate,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => sendOutInfo.doorplate = $event),
        placeholder: "填写门牌号码",
        onBlur: setLocal,
        ref_key: "doorplateOut",
        ref: doorplateOut
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "联系人",
        modelValue: sendOutInfo.name,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => sendOutInfo.name = $event),
        placeholder: "输入联系人姓名",
        ref_key: "nameOut",
        ref: nameOut
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "手机号",
        modelValue: sendOutInfo.phone,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => sendOutInfo.phone = $event),
        placeholder: "输入手机号码",
        maxlength: "11",
        type: "tel",
        ref_key: "phoneOut",
        ref: phoneOut
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "取件时间",
        modelValue: sendOutInfo.date,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => sendOutInfo.date = $event),
        placeholder: "选择期望上门时间",
        readonly: "",
        onClick: _withModifiers(dealAddress, ["stop"])
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: showTime.value,
        "onUpdate:show": _cache[12] || (_cache[12] = $event => showTime.value = $event),
        round: "",
        position: "bottom",
        style: {
          height: '30%'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
        }, [_createVNode(DateShose, {
          ref_key: "dateShose",
          ref: dateShose,
          onTime: timeChoose
        }, null, 512)])]),
        _: 1
      }, 8, ["show"])])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, [_createTextVNode(" 寄回信息 "), sendBack.value ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(与收取件一致)")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        color: "#b50029",
        onClick: switchState
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(sendBack.value ? '点击修改' : '点击收起'), 1)]),
        _: 1
      })]), !sendBack.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_van_field, {
        label: "省市区",
        modelValue: sendBackInfo.area,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => sendBackInfo.area = $event),
        placeholder: "选择省市区",
        readonly: "",
        clickable: "",
        onClick: _cache[14] || (_cache[14] = $event => showBackArea.value = true),
        class: "adr"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: showBackArea.value,
        "onUpdate:show": _cache[17] || (_cache[17] = $event => showBackArea.value = $event),
        position: "bottom",
        style: {
          height: '40%'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          "show-toolbar": "",
          columns: areaBackList.value,
          onChange: areaBackChange,
          onConfirm: _cache[15] || (_cache[15] = $event => areaChoose($event, 'back')),
          onCancel: _cache[16] || (_cache[16] = $event => showBackArea.value = false),
          ref_key: "backPicker",
          ref: backPicker
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        label: "街道小区",
        modelValue: sendBackInfo.adr,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => sendBackInfo.adr = $event),
        placeholder: "填写街道、小区",
        onBlur: _cache[19] || (_cache[19] = $event => adrBlur('back')),
        class: "adr",
        ref_key: "adrBack",
        ref: adrBack
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "门牌号码",
        modelValue: sendBackInfo.doorplate,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => sendBackInfo.doorplate = $event),
        placeholder: "填写门牌号码",
        ref_key: "doorplateBack",
        ref: doorplateBack
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "联系人",
        modelValue: sendBackInfo.name,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => sendBackInfo.name = $event),
        placeholder: "输入联系人姓名",
        ref_key: "nameBack",
        ref: nameBack
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "手机号",
        modelValue: sendBackInfo.phone,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => sendBackInfo.phone = $event),
        placeholder: "输入手机号码",
        maxlength: "11",
        type: "tel",
        ref_key: "phoneBack",
        ref: phoneBack
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        style: _normalizeStyle({
          'margin-bottom': orderDetail.value.s_id == 33 || orderDetail.value.s_id == 51 || orderDetail.value.s_id == 52 ? '' : '100px'
        })
      }, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_van_field, {
        modelValue: remark.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => remark.value = $event),
        type: "textarea",
        placeholder: "选填写订单备注",
        autosize: "",
        label: ""
      }, null, 8, ["modelValue"]), _createElementVNode("div", {
        class: "note"
      }, [_hoisted_16, _hoisted_17, _createElementVNode("span", {
        class: "serviceNo",
        onClick: callCS
      }, "服务热线：40066-31115")])])], 4), orderDetail.value.s_id == 33 || orderDetail.value.s_id == 51 || orderDetail.value.s_id == 52 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [orderDetail.value.is_insured ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          label: "投保金额",
          modelValue: orderDetail.value.insured_money,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => orderDetail.value.insured_money = $event),
          readonly: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          label: "保费",
          modelValue: orderDetail.value.pay_total,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => orderDetail.value.pay_total = $event),
          readonly: "",
          error: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })])])) : (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
        class: "input",
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => price.value = $event),
        type: "number",
        onInput: _cache[27] || (_cache[27] =
        //@ts-ignore
        (...args) => _unref(priceInput) && _unref(priceInput)(...args)),
        placeholder: "输入物品实际价值，¥1-¥2,000"
      }, null, 544), [[_vModelText, price.value]]), price.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createTextVNode(" 应付保费 "), _createElementVNode("span", _hoisted_27, "¥" + _toDisplayString(fyp.value), 1), _hoisted_28, _hoisted_29])) : _createCommentVNode("", true)]), _hoisted_30, _createElementVNode("div", _hoisted_31, [_createVNode(_component_van_checkbox, {
        modelValue: accord.value,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => accord.value = $event),
        "icon-size": "14px"
      }, {
        default: _withCtx(() => [_createTextVNode(" 阅读并同意 "), _createElementVNode("span", {
          style: {
            "color": "#2193f1",
            "font-size": "14px"
          },
          onClick: _withModifiers(goAccord, ["stop"])
        }, "《物流运输保价须知》")]),
        _: 1
      }, 8, ["modelValue"])])])]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, [fyp.value > 0 && !orderDetail.value.is_insured && (orderDetail.value.s_id == 33 || orderDetail.value.s_id == 51 || orderDetail.value.s_id == 52) ? (_openBlock(), _createElementBlock("span", _hoisted_33, "¥" + _toDisplayString(fyp.value), 1)) : _createCommentVNode("", true), fyp.value > 0 && !orderDetail.value.is_insured && (orderDetail.value.s_id == 33 || orderDetail.value.s_id == 51 || orderDetail.value.s_id == 52) ? (_openBlock(), _createBlock(_component_van_button, {
        key: 1,
        round: "",
        block: "",
        color: orderDetail.value.is_over_days ? '#ccc' : '#b50029',
        onClick: toSave
      }, {
        default: _withCtx(() => [_createTextVNode("立即支付")]),
        _: 1
      }, 8, ["color"])) : (_openBlock(), _createBlock(_component_van_button, {
        key: 2,
        round: "",
        block: "",
        color: orderDetail.value.is_over_days ? '#ccc' : '#b50029',
        onClick: toSave
      }, {
        default: _withCtx(() => [_createTextVNode("提交预约")]),
        _: 1
      }, 8, ["color"]))]), _createVNode(_component_van_overlay, {
        show: overlayShow.value,
        "custom-style": {
          background: 'rgba(255,255,255,0.3)'
        }
      }, null, 8, ["show"])])) : (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_van_nav_bar, {
        title: "服务订单",
        "left-arrow": "",
        border: "",
        fixed: "",
        placeholder: "",
        onClickLeft: back
      }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("span", _hoisted_37, _toDisplayString(orderDetail.value.oc_id > 0 ? '预约成功' : '需人工预约'), 1), _hoisted_38, _createElementVNode("span", _hoisted_39, "订单状态为" + _toDisplayString(resStatus.value), 1)]), _createElementVNode("div", null, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("span", null, _toDisplayString(resStatus.value), 1)]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("span", null, _toDisplayString(orderDetail.value.create_time), 1)]), _createElementVNode("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, _toDisplayString(orderDetail.value.s_name), 1), _createElementVNode("span", _hoisted_48, "订单编号：" + _toDisplayString(orderDetail.value.vender_order_no), 1), _createElementVNode("span", _hoisted_49, "取件时间：" + _toDisplayString(orderDetail.value.date), 1), orderDetail.value.waybill_code_sender ? (_openBlock(), _createElementBlock("span", _hoisted_50, [_createTextVNode("寄出单号： "), _createElementVNode("span", {
        class: "num",
        onClick: _cache[29] || (_cache[29] = $event => openLogistics(orderDetail.value.trace_details_sender))
      }, _toDisplayString(orderDetail.value.waybill_code_sender), 1)])) : _createCommentVNode("", true), orderDetail.value.waybill_code_receiver ? (_openBlock(), _createElementBlock("span", _hoisted_51, [_createTextVNode("寄回单号： "), _createElementVNode("span", {
        class: "num",
        onClick: _cache[30] || (_cache[30] = $event => openLogistics(orderDetail.value.trace_details_receiver))
      }, _toDisplayString(orderDetail.value.waybill_code_receiver), 1)])) : _createCommentVNode("", true)])])])]), !shoesData.value ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_hoisted_54, _createVNode(_component_van_button, {
        class: "open",
        icon: showShoseInfo.value ? 'arrow-up' : 'arrow-down',
        type: "primary",
        size: "mini",
        "icon-position": "right",
        onClick: openShoseInfo
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(showShoseInfo.value ? '收起' : '展开'), 1)]),
        _: 1
      }, 8, ["icon"])]), _createElementVNode("div", _hoisted_55, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoesData.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "list",
          key: item.so_id
        }, [_createElementVNode("span", _hoisted_56, "鞋靴" + _toDisplayString(index + 1) + ": " + _toDisplayString(item.order_no), 1), _createElementVNode("div", _hoisted_57, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgs, (it, i) => {
          return _openBlock(), _createElementBlock("img", {
            class: "shose_img",
            src: it.img_url,
            alt: "",
            onClick: $event => previewImg(item.imgs, i),
            key: it.img_url
          }, null, 8, _hoisted_58);
        }), 128))]), item.flaw_tabs && item.flaw_tabs.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_hoisted_60, _createElementVNode("div", _hoisted_61, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.flaw_tabs, tab => {
          return _openBlock(), _createElementBlock("div", {
            key: tab.ft_id
          }, _toDisplayString(tab.name), 1);
        }), 128))])])) : _createCommentVNode("", true), item.in_reason ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_hoisted_63, _createElementVNode("div", _hoisted_64, [_createElementVNode("span", null, _toDisplayString(item.in_reason), 1)])])) : _createCommentVNode("", true)]);
      }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_hoisted_65, _createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [orderDetail.value.c_name ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(orderDetail.value.c_name.substring(0, 1)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_70, _toDisplayString(orderDetail.value.c_name), 1), _createElementVNode("span", _hoisted_71, _toDisplayString(orderDetail.value.c_phone), 1)]), _createElementVNode("div", _hoisted_72, [_createElementVNode("span", null, _toDisplayString(orderDetail.value.province) + _toDisplayString(orderDetail.value.city) + _toDisplayString(orderDetail.value.district) + _toDisplayString(orderDetail.value.c_address), 1)])])])]), _createElementVNode("div", null, [_hoisted_73, _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [orderDetail.value.receiver_back_name ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(orderDetail.value.receiver_back_name.substring(0, 1)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_77, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_78, _toDisplayString(orderDetail.value.receiver_back_name), 1), _createElementVNode("span", _hoisted_79, _toDisplayString(orderDetail.value.receiver_back_mobile), 1)]), _createElementVNode("div", _hoisted_80, [_createElementVNode("span", null, _toDisplayString(orderDetail.value.receiver_back_address), 1)])])])]), orderDetail.value.remark ? (_openBlock(), _createElementBlock("div", _hoisted_81, [_hoisted_82, _createElementVNode("div", _hoisted_83, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(orderDetail.value.remark), 1)])])])) : _createCommentVNode("", true), orderDetail.value.is_insured && orderDetail.value.rs_appid != 'lsxd' ? (_openBlock(), _createElementBlock("div", _hoisted_84, [_hoisted_85, _createElementVNode("div", _hoisted_86, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          label: "投保金额",
          modelValue: orderDetail.value.insured_money,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => orderDetail.value.insured_money = $event),
          readonly: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          label: "保费",
          modelValue: orderDetail.value.pay_total,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => orderDetail.value.pay_total = $event),
          readonly: "",
          error: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })])])) : _createCommentVNode("", true), soldier.value.name ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_hoisted_90, _createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createElementVNode("span", null, _toDisplayString(soldier.value.name), 1)]), _createElementVNode("div", _hoisted_93, [_hoisted_94, _createTextVNode(" " + _toDisplayString(soldier.value.phone) + " ", 1), _createElementVNode("a", {
        href: 'tel:' + soldier.value.real_phone + '',
        class: "phone_text phone_text1"
      }, "拨打", 8, _hoisted_95)]), _hoisted_96])])])])) : _createCommentVNode("", true), kfLink.value ? (_openBlock(), _createElementBlock("div", _hoisted_97, [_hoisted_98, _createElementVNode("span", _hoisted_99, [_createTextVNode(" 专属服务管家（客服）为您提供更便捷的服务体验，请 "), _createElementVNode("a", {
        href: kfLink.value,
        class: "custom_link",
        onClick: bindKfLink
      }, "点击这里", 8, _hoisted_100)])])) : _createCommentVNode("", true), _hoisted_101, _createElementVNode("div", _hoisted_102, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        color: "#b50029",
        onClick: callCS
      }, {
        default: _withCtx(() => [_createTextVNode("呼叫客服")]),
        _: 1
      })])])])), _createVNode(_component_van_overlay, {
        show: showKf.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("div", _hoisted_103, [_createVNode(_component_van_image, {
          class: "kf_img",
          width: "120",
          height: "120",
          round: "",
          src: require('../assets/kf.png')
        }, null, 8, ["src"]), _createVNode(_component_van_icon, {
          class: "cross",
          size: "20",
          color: "#818790",
          name: "cross",
          onClick: _cache[33] || (_cache[33] = $event => showKf.value = false)
        }), _createElementVNode("div", _hoisted_104, [_hoisted_105, _createElementVNode("span", _hoisted_106, [_createTextVNode("鞋靴寄出前， "), _createElementVNode("a", {
          href: kfLink.value,
          onClick: bindKfLink
        }, "请您添加您的专属客服", 8, _hoisted_107), _createTextVNode(" ，便于在鞋靴洗护过程中为您提供更加精准快捷的咨询服务。 ")])]), _createVNode(_component_van_button, {
          class: "btn",
          color: "#b50029",
          block: "",
          round: "",
          url: kfLink.value,
          onClick: bindKfLink
        }, {
          default: _withCtx(() => [_createTextVNode(" 去添加 ")]),
          _: 1
        }, 8, ["url"])])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_overlay, {
        show: showFail.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("div", _hoisted_108, [_createVNode(_component_van_image, {
          class: "kf_img",
          width: "120",
          height: "120",
          round: "",
          src: require('../assets/kf.png')
        }, null, 8, ["src"]), _createVNode(_component_van_icon, {
          class: "cross",
          size: "20",
          color: "#818790",
          name: "cross",
          onClick: _cache[35] || (_cache[35] = $event => showFail.value = false)
        }), _hoisted_109, _createVNode(_component_van_button, {
          class: "btn",
          color: "#b50029",
          block: "",
          round: "",
          onClick: callCS
        }, {
          default: _withCtx(() => [_createTextVNode(" 呼叫客服 ")]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_overlay, {
        show: showLogistics.value,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_110, [_createElementVNode("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, [_hoisted_113, _createVNode(_component_van_icon, {
          name: "cross",
          size: "20",
          color: "#818790",
          onClick: _cache[37] || (_cache[37] = $event => showLogistics.value = false)
        })]), _createVNode(_component_van_steps, {
          direction: "vertical",
          "active-color": "#1a88ee",
          active: 0
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logisticsInfo.value, item => {
            return _openBlock(), _createBlock(_component_van_step, {
              key: item.operationTime
            }, {
              default: _withCtx(() => [_createElementVNode("h3", null, _toDisplayString(item.operationRemark), 1), _createElementVNode("p", null, _toDisplayString(item.operationTime), 1)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
});